import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { recordNavigation, replaceLastNavigation, syncNavigationStackToPath } from '../utils/nativeBackNavigation';

/**
 * Tracks in-app route changes so portal back navigation can skip login/auth screens
 * and ignore tab-only query changes. Mount once inside BrowserRouter.
 */
const NavigationHistoryRecorder: React.FC = () => {
    const location = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        const fullPath = `${location.pathname}${location.search}`;

        if (navigationType === 'POP') {
            syncNavigationStackToPath(fullPath);
            return;
        }

        if (navigationType === 'REPLACE') {
            replaceLastNavigation(fullPath);
            return;
        }

        recordNavigation(fullPath);
    }, [location.pathname, location.search, navigationType]);

    return null;
};

export default NavigationHistoryRecorder;
